export const radius = {
  containers: {
    primary: '4px',
    secondary: '32px',
    tertiary: '8px',
    round: '50%',
  },
};
